import { ApolloClient, InMemoryCache } from '@apollo/client'
import { RestLink } from 'apollo-link-rest'

export enum RestEndpoints {
  Reach = 'reach',
}

const restLink = new RestLink({
  uri: '/',
  endpoints: {
    [RestEndpoints.Reach]:
      process.env.REACT_APP_REACH_GET_RATES_ENDPOINT ||
      'https://checkout.rch.how/v2.21/',
  },
})

export const restClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: restLink,
})
